import React from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";

// import styles here because otherwise they don't work in dev environment
// these imports are not necessary for production environment
import "react-select/dist/react-select.min.css";
import "@components/common/select_react/react_select_styles";

import CustomFieldValueRow from './custom_field_value_row';
import './styles/main.scss';


class CustomFieldsValueManagement extends React.Component {
  state = {
    visibleValues: this.props.customFieldValues,
    queryString: null,
    sortBy: "name"
  }

  updateSearch = (event) => {
    this.setState({ queryString: event.target.value });
  }

  handleSorting = (selection) => {
    this.setState({ sortBy: selection.value });
  }

  updateValues = (oldValue, newValue) => {
    const data = {
      data: {
        management_action: newValue ? "update" : "delete",
        brandfolder_key: BF.fx.brandfolder().key,
        custom_field_key: this.props.customFieldKey.key,
        old_value: oldValue,
        new_value: newValue
      }
    };
    $.ajax({
      type: 'PUT',
      url: "/api/v4/bulk_actions/assets/manage_custom_fields",
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      data: JSON.stringify(data),
      context: this,
      success: () => {
        this.updateVisibleValues(oldValue, newValue);
      }
    });
  }

  redirectToAllCustomFields() {
    document.getElementById("custom_fields_redirect").click();
  }

  updateVisibleValues(oldValue, newValue) {
    const { visibleValues } = this.state;
    let updatedValues;
    if (newValue) {
      updatedValues = Object.assign(visibleValues, { [newValue]: visibleValues[oldValue] });
    } else {
      updatedValues = Object.assign({}, visibleValues);
    }
    delete updatedValues[oldValue];
    this.setState({ visibleValues: updatedValues });
  }

  queriedValues() {
    const { visibleValues, queryString } = this.state;
    return Object.keys(visibleValues).filter((value) => (
      value.toLowerCase().includes(queryString.toLowerCase())));
  }

  sortedByValue() {
    const { visibleValues, queryString } = this.state;
    const valuesToSort = queryString ? this.queriedValues() : Object.keys(visibleValues);
    return valuesToSort.sort((a, b) => ((a.toLowerCase() < b.toLowerCase()) ? -1 : 1));
  }

  sortedByCount() {
    const { visibleValues, queryString } = this.state;
    const valuesToSort = queryString ? this.queriedValues() : Object.keys(visibleValues);
    return valuesToSort.sort((a, b) => ((visibleValues[a] < visibleValues[b]) ? 1 : -1));
  }

  sortedValues() {
    const { sortBy } = this.state;
    if (sortBy === "count") {
      return this.sortedByCount();
    }
    return this.sortedByValue();
  }

  renderSortingOptions() {
    return (
      <div className="sorting-options">
        <input
          id="custom-field-values-search"
          className="searchbar"
          type="text"
          placeholder={`Search ${Object.keys(this.props.customFieldValues).length} custom field values`}
          onChange={this.updateSearch}
        />
        <div className="sort-options">
          <div><p>{t('Sort by')}:</p></div>
          <Select
            className="select-custom-field-key-sorting"
            closeOnSelect
            onChange={this.handleSorting}
            options={[{ value: "name", label: t("Name") }, { value: "count", label: t("Count") }]}
            placeholder={t('Name')}
            value={this.state.sortBy}
            isSearchable={false}
          />
        </div>
      </div>
    );
  }

  renderNoCustomFields() {
    const { customFieldKey } = this.props;
    return (
      <div className="manage-custom-fields">
        {`${customFieldKey.name} does not have any custom values.`}
      </div>
    );
  }

  render() {
    const { customFieldValues, customFieldKey } = this.props;
    if (this.props.customFieldValues.length < 1) {
      return this.renderNoCustomFields();
    }
    return (
      <div className="manage-custom-field-values">
        <h2>Manage Custom Field Values for {customFieldKey.name}</h2>
        <hr />
        <span onClick={this.redirectToAllCustomFields} className="redirect">
          Custom Fields
        </span>
        <span className="selected-key">
          {` / ${customFieldKey.name}`}
        </span>
        {this.renderSortingOptions()}
        <div className="custom-fields-list">
          <div className="headers">
            <div className="headers-container">
              <h3 className="quarter-width">{t('Key')}</h3>
              <h3 className="twenty-width">{t('Values')}</h3>
              <h3 className="twenty-width"># {t('Assets')}</h3>
            </div>
          </div>
          { this.sortedValues().map((value) => (
            <div className="custom-field-value-row" key={value}>
              <CustomFieldValueRow
                customFieldKey={this.props.customFieldKey}
                value={value}
                count={customFieldValues[value]}
                updateValues={this.updateValues}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

CustomFieldsValueManagement.propTypes = {
  customFieldKey: PropTypes.shape({
    name: PropTypes.string,
    key: PropTypes.string,
  }).isRequired,
  customFieldValues: PropTypes.objectOf(PropTypes.number).isRequired
};

export default CustomFieldsValueManagement;
